

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
// import { Dropdown } from 'element-ui';
@Component({
  name: 'lb-dropdown'
  // components: {
  //   'el-dropdown': Dropdown
  // }
})
export default class extends Vue {
  @Prop({ default: 'click' }) private trigger!: string;
  @Prop() private type!: string;
  @Prop({ default: '' }) private size!: string;
  @Prop({ type: Boolean, default: true }) private hideOnClick!: boolean;
  @Prop({ default: 'bottom' }) private placement!: string;
  @Prop({ type: Boolean, default: true }) private visibleArrow!: boolean;
  @Prop({ default: 250 }) private showTimeout!: number;
  @Prop({ default: 150 }) private hideTimeout!: number;
  @Prop({ default: 0 }) private tabindex!: number;

  private handleCommand(command: any) {
    this.$emit('command', command);
  }

  private handleVisibleChange(val: any) {
    this.$emit('visible-change', val);
  }
}
